
import { computed, defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import SidebarAccount from "@/components/base/SidebarAccount.vue";
import { useRouter, useRoute } from "vue-router";
import { ROUTES } from "@/router/constants";
import ENV from "@/constants/env";
import { useStore } from "vuex";
import { USER_ACTIONS, USER_GETTERS } from "@/store/user";

export default defineComponent({
  name: "SidebarCommon",
  components: {
    SidebarAccount,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const dropdownToggleRef = ref(null);
    const gamesDropdownRef = ref(null);
    const dropdownMemesToggleRef = ref(null);
    const memesDropdownRef = ref(null);
    const isGamesDropdownOpen = ref(false);
    const isMemesDropdownOpen = ref(false);
    const currentYear = computed(() => new Date().getFullYear());

    // Handle dropdown toggle
    const toggleGamesDropdown = () => {
      isGamesDropdownOpen.value = !isGamesDropdownOpen.value;
    };

    const toggleMemesDropdown = () => {
      isMemesDropdownOpen.value = !isMemesDropdownOpen.value;
    };

    // Navigate to login page
    const navigateToLogin = () => {
      router.push({ name: ROUTES.login });
    };

    // Navigate to disclaimer page
    const goToDisclaimer = () => {
      router.push({ name: ROUTES.disclaimer });
    };

    // Listen for clicks outside to close dropdown
    const closeGamesDropdownOnOutsideClick = (event: MouseEvent) => {
      if (
        gamesDropdownRef.value &&
        dropdownToggleRef.value &&
        !gamesDropdownRef.value.contains(event.target as Node) &&
        !dropdownToggleRef.value.contains(event.target as Node)
      ) {
        isGamesDropdownOpen.value = false;
      }
    };

    const closeMemesDropdownOnOutsideClick = (event: MouseEvent) => {
      if (
        memesDropdownRef.value &&
        dropdownMemesToggleRef.value &&
        !memesDropdownRef.value.contains(event.target as Node) &&
        !dropdownMemesToggleRef.value.contains(event.target as Node)
      ) {
        isMemesDropdownOpen.value = false;
      }
    };

    // Listen for route changes to close dropdown
    const closeDropdownOnRouteChange = () => {
      isGamesDropdownOpen.value = false;
      isMemesDropdownOpen.value = false;
    };

    // Setup event listeners
    onMounted(() => {
      document.addEventListener("click", closeGamesDropdownOnOutsideClick);
      document.addEventListener("click", closeMemesDropdownOnOutsideClick);
      router.beforeEach(closeDropdownOnRouteChange);
    });

    // Clean up event listeners
    onBeforeUnmount(() => {
      document.removeEventListener("click", closeGamesDropdownOnOutsideClick);
      document.removeEventListener("click", closeMemesDropdownOnOutsideClick);
    });

    return {
      route,
      ROUTES,
      ENV,
      dropdownToggleRef,
      gamesDropdownRef,
      dropdownMemesToggleRef,
      memesDropdownRef,
      isGamesDropdownOpen,
      isMemesDropdownOpen,
      address: computed(() => store.getters[USER_GETTERS.ADDRESS_ELROND]),
      userLogoutElrond: () => store.dispatch(USER_ACTIONS.LOGOUT_ELROND),
      toggleGamesDropdown,
      toggleMemesDropdown,
      navigateToLogin,
      goToDisclaimer,
      currentYear,
    };
  },
});
